module.exports = __webpack_public_path__ + "static/img/egg_r_04.7374179.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_04.png
// module id = +frq
// module chunks = 1